jQuery( document ).ready(function($) {
     $('.list-menu__item span').click(function(){
       $(this).closest('.list-menu__item').toggleClass('active_item');
    })


  $('.annouce-slider').flickity({
  contain: true,
  pageDots: false,
prevNextButtons: false,
    autoPlay: 5000 ,
    wrapAround: true
});
  var $backToTop = $(".back-to-top");
  $backToTop.hide();

  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 100) {
      $backToTop.fadeIn();
    } else {
      $backToTop.fadeOut();
    }
  });

  $backToTop.on('click', function(e) {
    $("html, body").animate({scrollTop: 0}, 500);
  });

  $('.product-grid-container').addClass('grid-view-section');
    // Toggle between grid and list view
    $('.grid-view').click(function() {
        $(this).addClass('active');
        $('.list-view').removeClass('active');
        $('.product-grid-container').removeClass('list-view-section1').addClass('grid-view-section');
        $('#product-grid').removeClass('grid--4-col-desktop grid--2-col-tablet-down').addClass('grid--2-col-desktop grid--1-col-tablet-down');
    });

    $('.list-view').click(function() {
        $(this).addClass('active');
        $('.grid-view').removeClass('active');
        $('.product-grid-container').removeClass('grid-view-section1').addClass('list-view-section1');
        $('#product-grid').removeClass('grid--2-col-desktop grid--1-col-tablet-down').addClass('grid--4-col-desktop grid--2-col-tablet-down');

    });
  });




document.addEventListener("DOMContentLoaded", function () {
  const stickyForm = document.querySelector("product-sticky-form");
  const footer = document.querySelector("footer");

  if (stickyForm && footer) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Footer is visible → hide sticky form
            stickyForm.style.display = "none";
          } else {
            // Footer is not visible → show sticky form
            stickyForm.style.display = "";
          }
        });
      },
      {
        root: null, // viewport
        threshold: 0, // trigger as soon as footer touches viewport
      }
    );

    observer.observe(footer);
  }
});

// Accessibility-Fix: Schließen-Buttons in den BLOY-Loyalty-Widgets (Dritt-App) haben keinen zugänglichen Namen
// (nur ein SVG-Icon, kein Text/aria-label). Betrifft zwei unterschiedliche Widgets der App:
// - .BLOY-popup__action--close (Loyalty-Popup)
// - .BLOY-reminder__action--close (Reminder-Banner)
// Da wir den App-Code nicht direkt bearbeiten können, beobachten wir das DOM und ergänzen
// aria-label, sobald einer der Buttons erscheint.
(function () {
  var BLOY_CLOSE_SELECTOR = ".BLOY-popup__action--close, .BLOY-reminder__action--close";

  function patchBloyCloseButtons(root) {
    (root || document).querySelectorAll(BLOY_CLOSE_SELECTOR + ":not([aria-label])").forEach(function (btn) {
      btn.setAttribute("aria-label", "Schließen");
    });
  }

  patchBloyCloseButtons(document);

  var bloyObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(BLOY_CLOSE_SELECTOR)) {
          node.setAttribute("aria-label", "Schließen");
        }
        patchBloyCloseButtons(node);
      });
    });
  });

  bloyObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

// Accessibility-/SEO-Fix: Das "Verified Reviews"-Siegel-Bild im Judge.me-Bewertungswidget (Dritt-App)
// hat kein alt-Attribut. Da das Bild von der App per JS ins DOM eingefügt wird, ergänzen wir
// das alt-Attribut nachträglich per MutationObserver, sobald es erscheint.
(function () {
  var JDGM_BADGE_SELECTOR = ".jdgm-verified-badge__image img";
  var JDGM_BADGE_ALT_TEXT = "Judge.me verifizierte Kundenbewertungen";

  function patchJdgmBadgeAlt(root) {
    (root || document).querySelectorAll(JDGM_BADGE_SELECTOR + ":not([alt])").forEach(function (img) {
      img.setAttribute("alt", JDGM_BADGE_ALT_TEXT);
    });
  }

  patchJdgmBadgeAlt(document);

  var jdgmObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(JDGM_BADGE_SELECTOR)) {
          node.setAttribute("alt", JDGM_BADGE_ALT_TEXT);
        }
        patchJdgmBadgeAlt(node);
      });
    });
  });

  jdgmObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

// Akkordion für den "Zwei gute Gründe"-Block in der Produktbeschreibung (Kollagen-Booster-Bundle).
// Der Block kommt aus dem Rich-Text-Metafield (custom.beschreibung_lang) und ist reiner Fließtext
// (Überschrift + zwei H4/P-Boxen ohne eigenen Wrapper). Wir suchen gezielt die H3 mit diesem Text
// und verpacken sie zusammen mit den beiden folgenden Boxen in ein natives <details>/<summary>-
// Element (gleiches Akkordion-Muster wie z. B. Menü/Suche im Theme) - Startzustand: eingeklappt.
// Wirkt bewusst NUR auf diesen einen Block, nicht auf andere Überschriften der Produktbeschreibung.
(function () {
  var CONTAINER_SELECTOR = ".metafield-rich_text_field";
  var TRIGGER_TEXT = "Zwei gute Gründe";

  function buildAccordion(container) {
    var headings = container.querySelectorAll("h3");
    headings.forEach(function (h3) {
      if (h3.closest("details")) return; // bereits umgebaut
      if (h3.textContent.indexOf(TRIGGER_TEXT) === -1) return;

      var groupEls = [];
      var node = h3.nextElementSibling;
      while (node && !/^H[13]$/.test(node.tagName)) {
        groupEls.push(node);
        node = node.nextElementSibling;
      }
      if (!groupEls.length) return;

      var details = document.createElement("details");
      details.className = "ah-two-reasons";

      var summary = document.createElement("summary");
      summary.className = "ah-two-reasons__summary";

      h3.parentNode.insertBefore(details, h3);
      summary.appendChild(h3);
      details.appendChild(summary);
      groupEls.forEach(function (el) {
        details.appendChild(el);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(CONTAINER_SELECTOR).forEach(buildAccordion);
  });
})();
